export default {
  title: {
    id: 'buyback_refurbisher_search_product_title',
    defaultMessage: 'Create a BuyBack listing',
  },
  subTitle: {
    id: 'buyback_refurbisher_search_product_subtitle',
    defaultMessage:
      "Start by searching the Back Market catalog for an item you're ready to buy.",
  },
  noSearchTitle: {
    id: 'buyback_refurbisher_search_product_no_search_title',
    defaultMessage: 'What will you buy today?',
  },
  opportunitiesTitle: {
    id: 'bo_seller.trade_in.listings.opportunities_title',
    defaultMessage: 'You have {total} Trade-in opportunities',
  },
  opportunitiesDescription: {
    id: 'bo_seller.trade_in.listings.opportunities_description',
    defaultMessage: 'Sell more by sourcing these high-demand products.',
  },
  seeOpportunities: {
    id: 'bo_seller.trade_in.listings.opportunities_cta',
    defaultMessage: 'See opportunities',
  },
  searchInputLabel: {
    id: 'buyback_refurbisher_search_product_input_label',
    defaultMessage: 'Search',
  },
  searchInputPlaceholder: {
    id: 'buyback_refurbisher_search_product_input_placeholder',
    defaultMessage: 'Try "iPhone 8"',
  },
  searchLoading: {
    id: 'buyback_refurbisher_search_product_loading',
    defaultMessage: 'Searching the catalog...',
  },
  searchNoResultsTitle: {
    id: 'buyback_refurbisher_search_product_no_results_title',
    defaultMessage: 'No results found',
  },
  searchNoResultsText: {
    id: 'buyback_refurbisher_search_product_no_results_text',
    defaultMessage:
      'Try searching for another item in the Back Market catalog.',
  },
  resultsTitle: {
    id: 'bo_sellers-listing-search-product-results-title',
    defaultMessage: `{count, plural,
    =0 {0 result found for "{search}"}
    one {# result found for "{search}"}
    other {# results found for "{search}"}
  }`,
  },
}
